import "./LinkPill.css";

const LinkPill = ({ link, pillConfig, onDotsClick }) => {
  if (!link.enabled) return null;

  const { bgColor, textColor, borderColor, borderWidth, radius, shadow } =
    pillConfig;

  // Apply per-link style overrides if present
  const finalBgColor = link.style?.bgColor || bgColor;
  const finalTextColor = link.style?.textColor || textColor;
  const finalBorderColor = link.style?.borderColor || borderColor;

  const pillStyle = {
    backgroundColor: finalBgColor,
    color: finalTextColor,
    borderColor: finalBorderColor,
    borderWidth: `${borderWidth}px`,
    borderRadius: `${radius}px`,
    boxShadow: shadow ? "0 2px 8px rgba(0, 0, 0, 0.1)" : "none",
  };

  const handleClick = (e) => {
    if (link.url) {
      window.open(link.url, "_blank", "noopener,noreferrer");
    }
  };

  const handleDotsClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onDotsClick) {
      onDotsClick(link);
    }
  };

  const renderLeftIcon = () => {
    if (!link.icon || link.icon.type === "none") return null;

    if (link.icon.type === "emoji") {
      return <div className="link-pill-icon">{link.icon.value}</div>;
    }

    if (link.icon.type === "image" && link.icon.value) {
      return (
        <div className="link-pill-icon">
          <img src={link.icon.value} alt="" />
        </div>
      );
    }

    return null;
  };

  const renderRightIcon = () => {
    // Always show 3 vertical dots
    return (
      <div
        className="link-pill-right-icon link-pill-dots"
        onClick={handleDotsClick}
      >
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
      </div>
    );
  };

  return (
    <div className="link-pill-wrapper">
      <div className="link-pill-title-outside">{link.title}</div>
      <a
        href={link.url}
        className="link-pill"
        style={pillStyle}
        onClick={handleClick}
        target="_blank"
        rel="noopener noreferrer"
      >
        {renderLeftIcon()}
        <div className="link-pill-content">
          <div className="link-pill-text">{link.subtitle || link.title}</div>
        </div>
        {renderRightIcon()}
      </a>
    </div>
  );
};

export default LinkPill;
